// extracted by mini-css-extract-plugin
export default {"cursor":"TypeWritter_cursor__UuOYG","blink":"TypeWritter_blink__oCIdu"};